<div class="form configuration-sidebar" (click)="$event.stopPropagation()">
  <form [formGroup]="parameterForm">
    <div class="configuration-sidebar__header">
      <h2>Create Self-scheduling Configuration <span>{{totalCustomeConfig + 1}}</span></h2>
    </div>

    <div class="configuration-sidebar__content" formGroupName="general">
      <span class="note">
        <strong>Note :</strong> Default configuration will be applicable to not configured combinations.
      </span>

      <div class="form__group full-width">
        <label for="name" class="form__label">Configuration Name</label>
        <input type="text" formControlName="name" name="name" class="form__control" pInputText
          [appValidationMessage]="parameterForm.get('general.name')" [errorMessages]="{ required: 'Name is required'}">
      </div>

      <div class="form__group full-width">
        <label for="description" class="form__label">Description</label>
        <textarea pInputTextarea formControlName="description" name="description" class="form__textarea"
          [appValidationMessage]="parameterForm.get('general.description')"
          [errorMessages]="{ required: 'Description is required'}"></textarea>
      </div>
    </div>
    <div class="parameters-box" formGroupName="parameter">
      <label for="branch" class="form__label">Parameters</label>

      <div class="col">
        <div class="form__group">
          <label for="name" class="form__label">Branch</label>
          <p-multiSelect [appValidationMessage]="parameterForm.get('parameter.branch')"
            class="form__multiSelect select-box" [options]="branchOptions" formControlName="branch"
            [errorMessages]="{ required: 'Branch is required'}" optionLabel="name" optionValue="value"
            placeholder="Select Branch" selectedItemsLabel="{0} Branch Selected">
          </p-multiSelect>
        </div>

        <div class="form__group">
          <label for="classification" class="form__label">Classification</label>
          <p-multiSelect class="form__multiSelect select-box"
            [appValidationMessage]="parameterForm.get('parameter.classification')" [options]="classificationOptions"
            optionLabel="name" optionValue="value" [errorMessages]="{ required: 'Classification is required'}"
            formControlName="classification" placeholder="Select classification"
            selectedItemsLabel="{0} Classification Selected">
          </p-multiSelect>
        </div>

        <div class="form__group">
          <label for="insurance" class="form__label">Insurance</label>
          <p-multiSelect class="form__multiSelect select-box"
            [appValidationMessage]="parameterForm.get('parameter.insurance')" [options]="insuranceOptions"
            optionLabel="name" [errorMessages]="{ required: 'Insurance is required'}" optionValue="name"
            formControlName="insurance" placeholder="Select Insurance" selectedItemsLabel="{0} Insurance Selected">
          </p-multiSelect>
        </div>
      </div>
    </div>

    <div class="expected-result">
      <h3>Expected Result</h3>
      <div class="col">
        <div class="form__group" formGroupName="template">
          <label for="template" class="form__label">Appointment invitation template</label>
          <p-select class="form__dropdown select-box" [options]="subTemplateOptions" optionLabel="name"
            optionValue="value" formControlName="templateId" placeholder="Select Template" 
            (onChange)="onChangeTemplate($event)" selectedItemsLabel="{0} Template Selected">
          </p-select>
        </div>
      </div>

      <div class="self-scheduling-outer__preview-btns">
        <a href="javascript:void(0);" class="btn btn--preview-btn" (click)="EmailPreviewClick()">
          <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.5627 7.30533C12.5627 8.83288 11.3243 10.0711 9.79685 10.0711C8.2693 10.0711 7.03101 8.83288 7.03101 7.30533C7.03101 5.77777 8.2693 4.53952 9.79685 4.53952C11.3243 4.53952 12.5627 5.77777 12.5627 7.30533Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M1 7.3053C2.1748 3.56489 5.6692 0.851746 9.79729 0.851746C13.9254 0.851746 17.4198 3.56492 18.5946 7.3053C17.4198 11.0457 13.9254 13.7589 9.79729 13.7589C5.66919 13.7589 2.17478 11.0457 1 7.3053Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          Preview Email
        </a>
        <a href="javascript:void(0);" class="btn btn--preview-btn" (click)="SMSPreviewClick()">
          <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.5627 7.30533C12.5627 8.83288 11.3243 10.0711 9.79685 10.0711C8.2693 10.0711 7.03101 8.83288 7.03101 7.30533C7.03101 5.77777 8.2693 4.53952 9.79685 4.53952C11.3243 4.53952 12.5627 5.77777 12.5627 7.30533Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M1 7.3053C2.1748 3.56489 5.6692 0.851746 9.79729 0.851746C13.9254 0.851746 17.4198 3.56492 18.5946 7.3053C17.4198 11.0457 13.9254 13.7589 9.79729 13.7589C5.66919 13.7589 2.17478 11.0457 1 7.3053Z"
              stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          Preview SMS
        </a>
      </div>

      <div *ngIf="selectedTemplate?.isAppInvitationTagPresent" class="self-scheduling-outer__appointmetn-box"
        formGroupName="selfScheduling">
        <div class="col">
          <label for="isFreshRemoteTypeAppointment" class="form__label full-width">Default appointment options
            for Fresh appointments</label>
          <div class="form__group">
            <div class="input-edit-table">
              <p-checkbox name="isFreshRemoteTypeAppointment" formControlName="isFreshRemoteTypeAppointment"
                binary="true" label="Remote"></p-checkbox>
              <span>(Online Appointment)</span>
            </div>
          </div>
          <div class="form__group">
            <div class="input-edit-table">
              <p-checkbox name="isFreshFacilityTypeAppointment" formControlName="isFreshFacilityTypeAppointment"
                binary="true" label="Facility"></p-checkbox>
              <span>(Clinic Visit)</span>
            </div>
          </div>
        </div>
        <div class="col">
          <label for="isCancellationAllowed" class="form__label full-width">Allow Reschedule & Cancel
            appointment</label>
          <div class="form__group">
            <div class="input-edit-table form__checkbox-outer">
              <p-checkbox name="isCancellationAllowed" formControlName="isCancellationAllowed" binary="true"
                label="Cancel Appointment" inputId="isCancellationAllowed1"></p-checkbox>
                <label class="checkbox-text" for="isCancellationAllowed1">Cancel Appointment</label>
            </div>

            <ng-container *ngIf="parameterForm.get('selfScheduling.isCancellationAllowed')?.value">
              <div class="appointment-block-box">
                <div class="form__group">
                  <label for="isLimitNoOfCancelAppointments" class="form__label">Limit no. of
                    attempts</label>
                  <div class="radios">
                    <div class="input-edit-table form__radio-outer">
                      <p-radioButton name="isLimitNoOfCancelAppointments"
                        formControlName="isLimitNoOfCancelAppointments" [value]="true" label="Yes" inputId="LimitNoOfCancelAppointmentsFixed"></p-radioButton>
                      <span class="radio-button-text" for="LimitNoOfCancelAppointmentsFixed">(Fixed)</span>
                    </div>
                    <div class="input-edit-table form__radio-outer">
                      <p-radioButton name="isLimitNoOfCancelAppointments"
                        formControlName="isLimitNoOfCancelAppointments" [value]="false" label="No" inputId="LimitNoOfCancelAppointmentsUnlimited"></p-radioButton>
                      <span class="radio-button-text" for="LimitNoOfCancelAppointmentsUnlimited">(Unlimited)</span>
                    </div>
                  </div>
                </div>
                <div class="form__group allowed" style="margin-bottom: -1.5rem"
                  *ngIf="parameterForm.get('selfScheduling.isLimitNoOfCancelAppointments')?.value">
                  <label for="maxCancelAllowed" class="form__label">Max. no. of allowed
                    attempts</label>
                  <input type="number" name="maxCancelAllowed" formControlName="maxCancelAllowed"
                    [errorMessages]="{ required: 'Max allowed attempt is required'}"
                    [appValidationMessage]="parameterForm.get('selfScheduling.maxCancelAllowed')" class="form__control"
                    pInputText maxlength="100" />
                  <span >(Ex: 3)</span>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="form__group">
            <div class="input-edit-table form__checkbox-outer">
              <p-checkbox name="isRescheduleAllowed" formControlName="isRescheduleAllowed" binary="true"
                label="Reschedule Appointment" inputId="isRescheduleAllowed1"></p-checkbox>
                <label class="checkbox-text" for="isRescheduleAllowed1">Reschedule Appointment</label>
            </div>

            <div class="appointment-block-box">
              <ng-container *ngIf="parameterForm.get('selfScheduling.isRescheduleAllowed')?.value">
                <div class="form__group">
                  <label for="isLimitNoOfRescheduleAppointments" class="form__label">Limit no. of
                    attempts</label>
                  <div class="radios">
                    <div class="input-edit-table form__radio-outer">
                      <p-radioButton name="isLimitNoOfRescheduleAppointments"
                        formControlName="isLimitNoOfRescheduleAppointments" [value]="true" label="Yes" inputId="LimitNoOfRescheduleAppointmentsFixed">
                      </p-radioButton>
                      <span class="radio-button-text" for="LimitNoOfRescheduleAppointmentsFixed">(Fixed)</span>
                    </div>
                    <div class="input-edit-table form__radio-outer">
                      <p-radioButton name="isLimitNoOfRescheduleAppointments"
                        formControlName="isLimitNoOfRescheduleAppointments" inputId="LimitNoOfRescheduleAppointmentsUnlimited" [value]="false" label="No">
                      </p-radioButton>
                      <span class="radio-button-text" for="LimitNoOfRescheduleAppointmentsUnlimited">(Unlimited)</span>
                    </div>
                  </div>
                </div>
                <div class="form__group allowed"
                  *ngIf="parameterForm.get('selfScheduling.isLimitNoOfRescheduleAppointments')?.value">
                  <label for="maxRescheduleAllowed" class="form__label">Max. no. of allowed
                    attempts</label>
                  <input type="number" name="maxRescheduleAllowed"
                    [errorMessages]="{ required: 'Max allowed attempt is required'}"
                    [appValidationMessage]="parameterForm.get('selfScheduling.maxRescheduleAllowed')"
                    formControlName="maxRescheduleAllowed" class="form__control" pInputText maxlength="100" />
                  <span>(Ex: 3)</span>
                </div>
              </ng-container>

              <div class="form__group rescheduling-appt">
                <label for="isRescheduleRemoteAppointmentType" class="form__label">Default appointment
                  options while rescheduling</label>
                <div class="input-edit-table form__checkbox-outer">
                  <p-checkbox name="isRescheduleRemoteAppointmentType"
                    formControlName="isRescheduleRemoteAppointmentType" binary="true" label="Remote" inputId="RescheduleRemoteAppointmentTypeOnlineAppointment"></p-checkbox>
                  <span class="checkbox-text" for="RescheduleRemoteAppointmentTypeOnlineAppointment">(Online Appointment)</span>
                </div>
                <div class="input-edit-table form__checkbox-outer">
                  <p-checkbox name="isRescheduleFacilityAppointmentType"
                    formControlName="isRescheduleFacilityAppointmentType" binary="true" label="Facility" inputId="RescheduleFacilityAppointmentTypeClinicVisit"></p-checkbox>
                  <span class="checkbox-text" for="RescheduleFacilityAppointmentTypeClinicVisit">(Clinic Visit)</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="configuration-sidebar__footer">
      <button *ngIf="showAddAndCreateButton" class="btn btn--primary mb-0" (click)="onSaveConfig(true)">Create and Add
        another</button>
      <button class="btn btn--primary mb-0" (click)="onSaveConfig()">Create</button>
    </div>
  </form>
</div>


<p-dialog [(visible)]="showDuplicateSelectionPopup" appendTo="body" [modal]="true" [responsive]="true">
  <div class="configuration-popup-outer">
    <div class="configuration-popup-outer__title">
      <h2>
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0.5C4.032 0.5 0 4.532 0 9.5C0 14.468 4.032 18.5 9 18.5C13.968 18.5 18 14.468 18 9.5C18 4.532 13.968 0.5 9 0.5ZM9.9 14H8.1V8.6H9.9V14ZM9.9 6.8H8.1V5H9.9V6.8Z"
            fill="#484848" />
        </svg>
        Partial Duplicate Configuration Found
      </h2>

    </div>
    <div class="configuration-popup-outer__content confirm-availability">
      <div class="partial-duplicate">
        <p>The current configuration contains duplicate parameter values.</p>
        <p>Please review and deselect the duplicates before proceeding.</p>

        <div class="confirm-availability__table-box">
          <table class="confirm-availability__custom-tables">
            <thead>
              <tr>
                <th class="confirm-availability__th">Parameter</th>
                <th class="confirm-availability__th">Input</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let param of duplicateParameters">
                <td class="confirm-availability__td">{{param?.type}}</td>
                <td class="confirm-availability__td">{{param?.values}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div class="full-width">
            <div class="input-edit-table">
              <p-checkbox name="group7" binary="true"
                label="Select the checkbox to deselect the duplicate parameter values."></p-checkbox>
            </div>
          </div> -->
        <p class="error">
          No duplicate input values have been deselected. <br>
          Please deselect the configuration to proceed or cancel the action.</p>
      </div>

    </div>

    <div class="configuration-popup-outer__btn-block">
      <a class="btn btn--secondary clear-filter" (click)="cancelDiscard()"> No, Cancel</a>
      <button class="btn btn--primary" (click)="removeDuplicateSelection()">Yes, Proceed</button>
    </div>
  </div>
</p-dialog>